// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CONVERT_TO_ASM_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CONVERT_TO_ASM,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      asmVendor: {
        kind: 'enum',
        required: true,
        choices: [
          'Agilent Gen5',
          'Agilent Gen5 Image',
          'Agilent OpenLab CDS',
          'Agilent TapeStation Analysis',
          'AppBio AbsoluteQ',
          'AppBio QuantStudio RT-PCR',
          'AppBio QuantStudio Design & Analysis',
          'Benchling Waters Empower Adapter',
          'Beckman Coulter Biomek',
          'Beckman Echo Plate Reformat',
          'BMG Labtech SMART Control',
          'BMG Labtech MARS',
          'Beckman Coulter PharmSpec',
          'Beckman Coulter Vi-Cell BLU',
          'Beckman Coulter Vi-Cell XR',
          'BD Biosciences FACSDiva',
          'Bio-Rad Bio-Plex Manager',
          'Bio-Rad CFX Maestro',
          'ChemoMetec NC View',
          'ChemoMetec Nucleoview',
          'CTL ImmunoSpot',
          'Cytiva Biacore Insight',
          'Cytiva Biacore T200 Control',
          'Cytiva Biacore T200 Evaluation',
          'Cytiva Unicorn',
          'FlowJo',
          'Luminex INTELLIFLEX',
          'Luminex xPONENT',
          'Mabtech Apex',
          'MSD Methodical Mind',
          'Molecular Devices SoftMax Pro',
          'MSD Discovery Workbench',
          'Revvity Matrix',
          'NovaBio Flex2',
          'PerkinElmer Envision',
          'Qiacuity dPCR',
          'Revvity Kaleido',
          'Roche Cedex BioHT',
          'Roche Cedex HiRes',
          'Tecan Magellan',
          'Benchling Thermo Fisher Scientific Chromeleon',
          'Thermo Fisher Scientific Genesys30',
          'Thermo Fisher Scientific Genesys On-Board',
          'Thermo Fisher Scientific NanoDrop 8000',
          'Thermo Fisher Scientific NanoDrop Eight',
          'Thermo Fisher Scientific Nanodrop One',
          'Thermo Fisher Scientific Qubit 4',
          'Thermo Fisher Scientific Qubit Flex',
          'Thermo Fisher Scientific VISIONlite',
          'Thermo Fisher Scientific SkanIt',
          'Unchained Labs Lunatic & Stunner'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
